module.exports = __webpack_public_path__ + "img/clear-torch.5024853f.jpg";